<template>
  <div class="bg-white border p-2 mt-3">
    <div class="table-responsive position-relative"
      :class="{ 'with-actions-gap': localUsers.length < 4, 'opacity-50': loading }">
      <table class="table">
        <caption class="sr-only" data-no-export>{{ i18n('Local user list') }}</caption>
        <thead>
          <tr class="d-none d-lg-table-row">
            <th scope="col">{{ i18n('Avatar') }}</th>
            <th scope="col">{{ i18n('Id') }}</th>
            <th scope="col">{{ i18n('Provider') }}</th>
            <th scope="col">{{ i18n('First Name') }}</th>
            <th scope="col">{{ i18n('Last Name') }}</th>
            <th scope="col">{{ i18n('Email') }}</th>
            <th data-no-export scope="col" style="min-width: 48px">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <LocalUserListItem v-for="localUser in localUsers" :localUser="localUser" :key="localUser.id"
            @edit="showLocalUserModal" @password="showLocalUserPasswordModal" @deleted="$emit('deleted', $event)"
            @updated="$emit('updated', $event)" @updating="$emit('updating', $event)" />
          <EmptyListItem v-if="!localUsers || localUsers.length == 0" :loading="loading" :colspan="7" />
          <LazyLoadListItem v-if="!loading && (lazyLoad || autoLazyLoad)" :autoLazyLoad="autoLazyLoad" :colspan="7"
            @next="$emit('next', $event)" />
        </tbody>
      </table>
      <div class="position-absolute h-100 w-100 top-0" @click.stop v-if="loading"></div>
    </div>
  </div>
  <LocalUserModal ref="LocalUserModal" @updated="$emit('updated', $event)" />
  <LocalUserPasswordModal ref="LocalUserPasswordModal" @updated="$emit('updated', $event)" />
</template>

<script>
import LocalUserListItem from "@/components/localUser/LocalUserListItem.vue";
import LocalUserModal from "@/components/localUser/LocalUserModal.vue";
import LocalUserPasswordModal from "@/components/localUser/LocalUserPasswordModal.vue";
import EmptyListItem from "@/components/common/list/EmptyListItem.vue";
import LazyLoadListItem from "@/components/common/list/LazyLoadListItem.vue";
import Tooltip from "@/components/common/layout/Tooltip.vue";

export default {
  components: {
    LocalUserListItem,
    LocalUserModal,
    LocalUserPasswordModal,
    EmptyListItem,
    LazyLoadListItem,
    Tooltip,
  },
  emits: [
    'updated',
    'deleted',
    'updated',
    'updating',
    'next',
  ],
  props: {
    loading: Boolean,
    lazyLoad: Boolean,
    autoLazyLoad: Boolean,
    localUsers: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    showLocalUserModal(localUser) {
      if (!this.$refs.LocalUserModal) return;
      this.$refs.LocalUserModal.show(localUser.id);
    },
    showLocalUserPasswordModal(localUser) {
      if (!this.$refs.LocalUserPasswordModal) return;
      this.$refs.LocalUserPasswordModal.show(localUser.id);
    },
  },
};
</script>